export default "__VITE_ASSET__bVwBuFex__"